var _title, _desc, _defs, _g;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgArrow = function SvgArrow(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), title === undefined ? _title || (_title = /*#__PURE__*/React.createElement("title", null, "ic_chevron_right_black_24px")) : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "04-metrics-list--design-prod-r2",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    transform: "translate(-800.000000, -689.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "data-series-panel-_expand-tree",
    transform: "translate(746.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "content"
  }, /*#__PURE__*/React.createElement("g", {
    id: "search-_normal-state",
    transform: "translate(0.000000, 117.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "data-series-_open-state",
    transform: "translate(0.000000, 52.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "category-_compartment",
    transform: "translate(0.000000, 512.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "content",
    transform: "translate(56.000000, 10.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "open-close"
  }, /*#__PURE__*/React.createElement("g", {
    id: "close"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ic_chevron_right_black_24px"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Shape",
    points: "0 0 20 0 20 20 0 20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.74583333,5.5875 L7.74583333,5.5875 C7.42126246,5.91207087 7.42097557,6.4382157 7.74519231,6.76314033 L10.975,10 L7.74519231,13.2368597 C7.42097557,13.5617843 7.42126246,14.0879291 7.74583333,14.4125 L7.74583333,14.4125 C8.07030062,14.7369673 8.59636604,14.7369673 8.92083333,14.4125 L13.3333333,10 L8.92083333,5.5875 C8.59636604,5.26303271 8.07030062,5.26303271 7.74583333,5.5875 Z",
    id: "Shape",
    fill: "#ABBBCA",
    fillRule: "nonzero"
  })))))))))))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgArrow, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/arrow.426a387b.svg";
export { ForwardRef as ReactComponent };